<script setup >
import Molecule from './Molecule.vue';
import {defineEmits, defineProps} from 'vue';

defineProps({
    molecules: {
        type: Array,
        required: true
    },
    current: {
        type: Object,
        required: false
    }
});

const emit = defineEmits(['select']);

const atSelect = (molecule) => {
    emit('select', molecule);
};
</script>

<template>
    <div class="MoleculeTable">
        <div v-for="(row, index) in molecules" :key="index" class="row">
            <Molecule v-for="(molecule, idx) in row" :key="idx" :molecule="molecule" @select="atSelect" :is-active="current?.label === molecule.label" />
        </div>
    </div>
</template>


<style lang="scss" scoped>
.MoleculeTable {
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;

    .row {
        display: flex;
        gap: 10px;
    }
}
</style>
